<template>
    <div class="upload_background_image">
        <label class="select_file">
            <span class="icon"><img src="../../assets/img/change.svg" alt="change"></span>
            <span>部屋変更</span>
            <input type="file" class="upload_image" @change="uploadBackgroundImage" id="upload_image" style="display: none;">
        </label>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import {loadImage} from '../../assets/js/loadImageByPromise'
    import {compressImage, checkLocalStorageAvailable} from '../../assets/js/util'
    import CONST from '../../assets/js/const'

    export default {
        name: "UploadBackgroundImage",
        methods: {
            ...mapActions('simulator', ["resetItemList"]),
            ...mapActions(["resetTimer"]),

            async uploadBackgroundImage() {
                const file = this.$el.querySelector('.upload_image').files[0];
                if ( !this.fileValidation(file) ) return alert('画像のアップロードに失敗しました。\njpeg形式の画像ファイルを選択してください。');

                this.$store.commit('setIsLoading', true);

                const url = URL.createObjectURL(file);

                const img = await loadImage(url);
                const compressed_base64_img = await compressImage(img, 1000000);

                this.setBackgroundImage( await loadImage(compressed_base64_img) );
                if ( checkLocalStorageAvailable() ) localStorage.setItem(CONST.LOCAL_STORAGE_IMG_KEY, compressed_base64_img);

                this.resetItemList();
                this.resetTimer();

                this.$store.commit('setIsLoading', false);
            },
            fileValidation(file) {
                if (!file) return false;
                if (file.type !== 'image/jpeg') return false;

                return true;
            },
            setBackgroundImage(img) {
                this.$store.commit('setBackgroundImage', img);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";

    img{ vertical-align: middle }

    .upload_background_image{
        display: flex;
        label{
            @extend .clickable;
            display: flex;
            align-items: center;
            color: white;
            text-align: center;
            background-color: #2F5597;
            padding: 0.3rem 0.75rem;
            font-size: 14px;
            > *:not(:last-child) { margin-right: 0.25rem }
            .icon{
                display: inline-block;
                width: 1.2rem;
                img{ width: 100%; }
            }
        }
    }
</style>
